//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Slider from '@/components/common/Slider'
import { MOBILE_MAX_WIDTH } from '@/const/breakpoints'
import { mapState } from 'vuex'
const Entities = require('html-entities').AllHtmlEntities

export default {
  name: 'CoursesSection',
  components: {
    Slider,
  },
  data() {
    return {
      isMobile: false,
      isNavHidden: false,
      Entities,
      MOBILE_MAX_WIDTH,
      sliderOptions: {
        slidesPerView: 3,
        loop: false,
        spacing: 20,
        breakpoints: {
          '(max-width: 1280px)': {
            slidesPerView: 2,
          },
          '(max-width: 860px)': {
            slidesPerView: 1,
            loop: false,
            spacing: 20,
            mode: 'free',
          },
        },
      },
    }
  },
  computed: {
    ...mapState(['i18n']),
    isSnakeAllowed() {
      return this.i18n.locale === 'ru'
    },
    courseCards() {
      const courseCards = this.$getCourses()
      if (!courseCards.coding) {
        return []
      }

      const coursesUrlPaths = courseCards.coding
        .filter((item) => item.isActive === true)
        .map((course) => course.urlPath)

      let coursesCards = this.$getBulletsMainSetting('_courseCards')
        .filter((item) => coursesUrlPaths.includes(item.url))
        .map((course) => {
          return {
            id: parseInt(course.id, 10),
            title: course.title,
            age: course.childrens_age,
            code: course.code,
            url: course.url,
          }
        })

      const urlPath = process.server
        ? this.$route.path
        : window.location.pathname
      coursesCards = coursesCards.filter((course) => urlPath !== course.url)

      return coursesCards || []
    },
    coursesTitle() {
      return this.$getTextMainSetting('detailCoursePageSliderTitle')
    },
  },
  mounted() {
    this.windowSizeHandler()
  },
  methods: {
    goToCourse(url) {
      window.location.href = this.localePath(url, this.i18n.locale)
    },
    windowSizeHandler() {
      setTimeout(() => {
        this.isMobile = window.innerWidth <= MOBILE_MAX_WIDTH
        this.isNavHidden =
          (this.courseCards.length <= 3 && window.innerWidth > 1280) ||
          (window.innerWidth <= 1280 && this.courseCards.length <= 2)
      }, 500)
    },
    getDirection() {
      return this.$direction()
    },
  },
}
